// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__oKPSU","nav":"Navbar_nav__FsbqY","navMenu":"Navbar_navMenu__lJ9fT","link":"Navbar_link__Z6GsF","logo":"Navbar_logo__grQMD"};